/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var styles = [".tooltip3[_ngcontent-%COMP%]   .tooltip-dialog[_ngcontent-%COMP%] {\n  width: 350px; }\n\n.tooltip3[_ngcontent-%COMP%] {\n  margin-bottom: 0; }"];
export { styles as styles };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/info-i/info-i.component.scss.shim.ngstyle.js
// module id = null
// module chunks = 